import { render, staticRenderFns } from "./NextAcc.vue?vue&type=template&id=61cb54f4&scoped=true"
import script from "./NextAcc.vue?vue&type=script&lang=js"
export * from "./NextAcc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cb54f4",
  null
  
)

export default component.exports